import { useEffect, useMemo } from "react";
import { SelectOption } from "@ir/ui";
import { useDeductionEdit } from "@/presentation/deduction/hooks/deduction";

const createOption = (label: string, value: string): SelectOption => ({ label, value });

export const useDeductionIntelligenceOptions = () => {
  const { getPriorities, getValidities, priorities, validities } = useDeductionEdit();

  useEffect(() => {
    getPriorities();
    getValidities();
  }, [getPriorities, getValidities]);

  const priorityList = useMemo(
    () => priorities?.data?.map(priority => createOption(priority.label, priority.value.toString())) ?? [],
    [priorities]
  );

  const validityList = useMemo(
    () => validities?.data?.map(validity => createOption(validity.label, validity.value.toString())) ?? [],
    [validities]
  );

  return {
    priorityList,
    validityList,
    isPrioritiesLoading: priorities?.isLoading,
    isValiditiesLoading: validities?.isLoading,
  };
};
